import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    // If we're not on the homepage, navigate there first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Already on homepage, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setIsMobileMenuOpen(false);
      }
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-white shadow-md'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-28">
          {/* Logo */}
          <div className="flex items-center">
            <button onClick={() => navigate('/')} className="cursor-pointer">
              <img
                src="https://customer-assets.emergentagent.com/job_8d25542c-8587-482a-aad2-b863376d4177/artifacts/fp4fbbig_base_logo_transparent_background.png"
                alt="KALEM Baustoffhandel"
                className="h-20 w-auto"
              />
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-[#8B1538] transition-colors font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('gewerke')}
              className="text-gray-700 hover:text-[#8B1538] transition-colors font-medium"
            >
              Gewerke
            </button>
            <button
              onClick={() => scrollToSection('ueber-uns')}
              className="text-gray-700 hover:text-[#8B1538] transition-colors font-medium"
            >
              Über uns
            </button>
            <button
              onClick={() => scrollToSection('warum-kalem')}
              className="text-gray-700 hover:text-[#8B1538] transition-colors font-medium"
            >
              Vorteile
            </button>
            <button
              onClick={() => scrollToSection('kontakt')}
              className="text-gray-700 hover:text-[#8B1538] transition-colors font-medium"
            >
              Kontakt
            </button>
          </nav>

          {/* CTA */}
          <div className="hidden lg:flex items-center">
            <Button
              onClick={() => scrollToSection('kontakt')}
              size="lg"
              className="bg-[#8B1538] hover:bg-[#6B0F2A] text-white transition-all duration-300 shadow-lg hover:shadow-xl px-8 py-6 text-lg font-semibold"
            >
              Anfrage stellen
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700 hover:text-[#8B1538] transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('home')}
                className="text-gray-700 hover:text-[#8B1538] transition-colors font-medium text-left"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('gewerke')}
                className="text-gray-700 hover:text-[#8B1538] transition-colors font-medium text-left"
              >
                Gewerke
              </button>
              <button
                onClick={() => scrollToSection('ueber-uns')}
                className="text-gray-700 hover:text-[#8B1538] transition-colors font-medium text-left"
              >
                Über uns
              </button>
              <button
                onClick={() => scrollToSection('warum-kalem')}
                className="text-gray-700 hover:text-[#8B1538] transition-colors font-medium text-left"
              >
                Vorteile
              </button>
              <button
                onClick={() => scrollToSection('kontakt')}
                className="text-gray-700 hover:text-[#8B1538] transition-colors font-medium text-left"
              >
                Kontakt
              </button>
              <div className="pt-4 border-t border-gray-200">
                <Button
                  onClick={() => scrollToSection('kontakt')}
                  className="w-full bg-[#8B1538] hover:bg-[#6B0F2A] text-white"
                >
                  Anfrage stellen
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};